import { Injectable } from '@angular/core';
import { UnsubscribeModel } from '../models/unsubscribe.model';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { MembershipService } from '../services/membership.service';
import { Observable } from 'rxjs';



@Injectable()
export class EmailResolver  {

    constructor(private service: MembershipService, private router: Router)
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<UnsubscribeModel> {
        const unsubscribe_model = new UnsubscribeModel();
        unsubscribe_model.email_token = route?.params?.email_token;

        unsubscribe_model.email_id = route?.data?.email_model?.email_id;
        unsubscribe_model.notification_category = route?.data?.email_model?.notification_category;
        unsubscribe_model.active_opt_out = route?.params?.email_model?.active_opt_out;
        return this.service.UnsubscribeEmail(unsubscribe_model.email_token, unsubscribe_model);
    }
}
